import React from 'react';

const Trialname = (props) => {
    return (
            <p className="team-position">
                {props.name}
            </p>
    );
};

export default Trialname;